/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Done_Add_NoteInputs */

const en_cook_done_add_note = /** @type {(inputs: Cook_Done_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a note or photo`)
};

const de_cook_done_add_note = /** @type {(inputs: Cook_Done_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz oder Foto hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a note or photo" |
*
* @param {Cook_Done_Add_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_done_add_note = /** @type {((inputs?: Cook_Done_Add_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Done_Add_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_done_add_note(inputs)
	return en_cook_done_add_note(inputs)
});